import { Items } from 'src/app/core/models/common/items.model';

export enum ColumnIds {
  TRACKING_NUMBER = 'trackingNumber',
  SORT_DATE = 'sortDate',
  SORT_CODE = 'sortCode',
  DESTINATION_CC = 'destinationCC',
  LENGTH = 'length',
  WIDTH = 'width',
  HEIGHT = 'height',
  WEIGHT_LB = 'weight',
  UOW_TYPE = 'uowType',
}

export const CONST = {
  SELECT_DATE: $localize`Select Date`,
  HEADER: $localize`World Wide Express Freight`,
  TRACKING_NUMBER: $localize`Tracking Number`,
  ENTER_TRACKING_NUMBER: $localize`Enter or upload Tracking Numbers`,
  FILE_UPLOAD: $localize`File Upload`,
  SUBMIT: $localize`Submit`,
  SELECT: $localize`Select`,
  SORT_CODE: $localize`Sort Code`,
  TRACKING_NUMBER_INVALID_ERROR: $localize`Please enter a valid Tracking Number`,
  LENGTH: $localize`Length`,
  WIDTH: $localize`Width`,
  HEIGHT: $localize`Height`,
  WEIGHT: $localize`Weight`,
  DESTINATION_CC: $localize`Destination CC`,
  SELECT_COUNTRY: $localize`Select Country`,
  DIMENSIONS_EXCEEDED: {
    HEADER: $localize`Dimensions Exceeded`,
    ORIGIN: $localize`Max dimension for origin country %country is %dimension in.`,
    DESTINATION: $localize`Max dimension for destination country %country is %dimension in.`,
    PROCEED: $localize`Do you want to proceed?`,
    CONFIRM_BUTTON: $localize`Yes`,
    REJECT_BUTTON: $localize`No`,
  },
  WEIGHT_ERROR: $localize`Origin weight exceeds, allowed %max.`,
};

export const ColumnText = {
  TRACKING_NUMBER: $localize`Tracking Number`,
  SORT_DATE: $localize`Sort Date`,
  SORT_CODE: $localize`Sort Code`,
  DESTINATION_CC: $localize`Destination CC`,
  LENGTH: $localize`Length (%unit)`,
  WIDTH: $localize`Width (%unit)`,
  HEIGHT: $localize`Height (%unit)`,
  WEIGHT_LB: $localize`Weight (%unit)`,
  UOW_TYPE: $localize`UOW Type`,
};

export const SORT_OPTIONS: Items[] = [
  { id: 'D1', selected: true },
  { id: 'D3', selected: true },
  { id: 'D9', selected: true },
  { id: 'L1', selected: true },
  { id: 'P1', selected: true },
  { id: 'P4', selected: true },
  { id: 'P7', selected: true },
  { id: 'S1', selected: true },
  { id: 'S7', selected: true },
];

export type WWEF = {
  trackingNumber: string;
  sortDate: string;
  sortCode: string;
  destination: string;
  length: number;
  width: number;
  height: number;
  weight: number | string;
  uowType: string;
};

export const COUNTRY_LIST = [
  {
    label: 'AUSTRIA-AT',
    value: 'AT',
  },
  {
    label: 'BELGIUM-BE',
    value: 'BE',
  },
  {
    label: 'BULGARIA-BG',
    value: 'BG',
  },
  {
    label: 'GERMANY-DE',
    value: 'DE',
  },
  {
    label: 'RUSSIA-RU',
    value: 'RU',
  },
  {
    label: 'AUSTRALIA-AU',
    value: 'AU',
  },
  {
    label: 'SWITZERLAND-CH',
    value: 'CH',
  },
  {
    label: 'CANADA-CA',
    value: 'CA',
  },
  {
    label: 'UNITEDSTATES-US',
    value: 'US',
  },
];

export const MOCK_TABLE_CONSTS: WWEF[] = [
  {
    trackingNumber: '1Z937254729',
    sortDate: 'May 2, 2023',
    sortCode: 'L1',
    destination: 'LU',
    length: 10,
    width: 10,
    height: 10,
    weight: 10,
    uowType: 'Pallet',
  },
  {
    trackingNumber: '1Z1212121212',
    sortDate: 'May 8, 2023',
    sortCode: 'L1',
    destination: 'LU',
    length: 10,
    width: 10,
    height: 10,
    weight: 10,
    uowType: 'Pallet',
  },
  {
    trackingNumber: '1Z943637192',
    sortDate: 'May 6, 2023',
    sortCode: 'D4',
    destination: 'LU',
    length: 10,
    width: 10,
    height: 10,
    weight: 10,
    uowType: 'Pallet',
  },
  {
    trackingNumber: '1Z987654321',
    sortDate: 'May 8, 2023',
    sortCode: 'D1',
    destination: 'DE',
    length: 10,
    width: 10,
    height: 10,
    weight: 10,
    uowType: 'Pallet',
  },
  {
    trackingNumber: '1Z123456789',
    sortDate: 'May 10, 2023',
    sortCode: 'D4',
    destination: 'DE',
    length: 10,
    width: 10,
    height: 10,
    weight: 10,
    uowType: 'Pallet',
  },
  {
    trackingNumber: '1Z343434719',
    sortDate: 'May 5, 2023',
    sortCode: 'D1',
    destination: 'LU',
    length: 10,
    width: 10,
    height: 10,
    weight: 10,
    uowType: 'Pallet',
  },
  {
    trackingNumber: '1Z937254729',
    sortDate: 'May 9, 2023',
    sortCode: 'L1',
    destination: 'LU',
    length: 10,
    width: 10,
    height: 10,
    weight: 10,
    uowType: 'Pallet',
  },
  {
    trackingNumber: '1Z943637192',
    sortDate: 'May 3, 2023',
    sortCode: 'D3',
    destination: 'DE',
    length: 10,
    width: 10,
    height: 10,
    weight: 10,
    uowType: 'Pallet',
  },
  {
    trackingNumber: '1Z937254654',
    sortDate: 'May 5, 2023',
    sortCode: 'D9',
    destination: 'DE',
    length: 10,
    width: 10,
    height: 10,
    weight: 10,
    uowType: 'Pallet',
  },
  {
    trackingNumber: '1Z937254865',
    sortDate: 'May 9, 2023',
    sortCode: 'P1',
    destination: 'LU',
    length: 10,
    width: 10,
    height: 10,
    weight: 10,
    uowType: 'Pallet',
  },
  {
    trackingNumber: '1Z937254989',
    sortDate: 'May 5, 2023',
    sortCode: 'P4',
    destination: 'LU',
    length: 10,
    width: 10,
    height: 10,
    weight: 10,
    uowType: 'Pallet',
  },
  {
    trackingNumber: '1Z937254787',
    sortDate: 'May 11, 2023',
    sortCode: 'P7',
    destination: 'DE',
    length: 10,
    width: 10,
    height: 10,
    weight: 10,
    uowType: 'Pallet',
  },
  {
    trackingNumber: '1Z937254726',
    sortDate: 'May 9, 2023',
    sortCode: 'S1',
    destination: 'LU',
    length: 10,
    width: 10,
    height: 10,
    weight: 10,
    uowType: 'Pallet',
  },
  {
    trackingNumber: '1Z937254766',
    sortDate: 'May 8, 2023',
    sortCode: 'S7',
    destination: 'DE',
    length: 10,
    width: 10,
    height: 10,
    weight: 10,
    uowType: 'Pallet',
  },
];
